import { builder } from '../../../../../common/js/configs';

export const commonCta = {
  cta: builder.holder({
    useCta: builder.boolean('use_cta', {
      defaultValue: false,
      l:'',
      d:''
    }),
    ctaLabel: builder.string('cta_label', {
      l:'',
      defaultValue: 'Visit website',
      d:'',
      if: 'use_cta'
    }),
    ctaLabelColor: builder.color('cta_label_color', {
      defaultValue: '#FFFFFF',
      l:'',
      d:'',
      if: 'use_cta'
    }),
    ctaBackgroundColor: builder.color('cta_background_color', {
      defaultValue: '#4185f4',
      l:'',
      d:'',
      if: 'use_cta'
    })
  })
};
